export const mutations = {
  'SET_TICKET_DETAIL'(state, data) {
    state.ticket_detail = data
  }
};